/**
 * `core/wordpress/mwwpform/recaptchaBadgeManager.js`
 * - Google reCAPTCHA バッジの管理
 *
 * 使用方法:
 * - import {manageBadgeReCAPTCHA} from "../wordpress/mwwpform/recaptchaBadgeManager.js";
 */


import {getNamespace} from "../../../utils/dom.js";


export function manageBadgeReCAPTCHA(data) {
  console.log("🎭 Managing reCAPTCHA Badge...");

  const namespace = getNamespace(data);

  if (namespace === "contact") {
    document.body.classList.add("visible-recaptcha");
  } else {
    document.body.classList.remove("visible-recaptcha");
  }
}
